import { Divider, Logo, Typography } from '@themenu/design-system'

export const Footer = () => {
  const fullYear = new Date().getFullYear()

  return (
    <div className="grid gap-16">
      <Divider gradientColor="rainbow" />

      <div className="flex flex-col gap-16 items-center md:flex-row md:justify-between md:gap-32">
        <Logo height={20} />
        <Typography variant="caption" className="text-center md:text-right">
          Número de Inscrição no PAT: 180629004 | Todos os direitos reservados.
          @swilebrasil {fullYear}.
        </Typography>
      </div>
    </div>
  )
}
